(function() { window.GUID_d77bc98b_e212_491d_bd87_ad538bf99f48 = { getGuid: function() { return "d77bc98b-e212-491d-bd87-ad538bf99f48"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ScriptErrorPopup extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            constructor(controlId, ...params) {
                super(controlId, ...params);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnControlRendered() {
                try {
                    this.$Control.trigger(`ready`);
                }
                catch (error) {
                    console.error("Error in OnControlRendered", error);
                }
            }
            OnBindEvents() {
                try {
                    CS.Helper.log("ScriptErrorPopup", "Binding events...");
                    const gridid = `${this.ControlId}-grid`;
                    this.$Control.append(`<div id=${gridid}></div>`);
                    this.LogErrorInPopup(gridid);
                    CS.Helper.log("ScriptErrorPopup", `Successfully bound events`);
                }
                catch (error) {
                    console.error("Error while binding to match card events", error);
                }
            }
            LogErrorInPopup(gridid) {
                try {
                    requestAnimationFrame(() => {
                        const $tbody = $(`#${gridid}`).closest(".popup").find("tbody");
                        if ($tbody.length === 0) {
                            console.error(`Container with id ${gridid} not found`);
                            return;
                        }
                        Controls.ScriptErrorStatic.Instance.errors.forEach((error) => {
                            $tbody.append(`<tr><td><div>${error}</div></td></tr>`);
                        });
                    });
                }
                catch (error) {
                    console.error("Error while binding to ScriptErrorPopup", error);
                }
            }
            OnDispose() { }
        }
        Controls.ScriptErrorPopup = ScriptErrorPopup;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=ScriptErrorPopup.js.map
